import { connect } from "react-redux";
import AutomaticSystems from "./AutomaticSystems";

function Gates() {
  return <AutomaticSystems />;
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Gates);
